import { useTranslation } from 'react-i18next';
import { Empty, Skeleton, Typography } from 'antd';
import { ProfileInfoResponse } from 'all-in-one-shared-api';
import { DependentGroup } from './components/DependentGroup';
import { useProfileInfoContext } from '../../contexts/profileInfo';

export const GET_PROFILE_KEY = 'getProfileInfo';
const DependentsPage = () => {
  const { t } = useTranslation();
  const { state: profileData, isLoading } = useProfileInfoContext();

  const { familyMembers, isEmployee } = getDependentSectionProps(profileData);
  const hasDependents = familyMembers ? familyMembers.length > 0 : false;
  const spouse = getSpouseData(familyMembers, isEmployee);
  const children = familyMembers.filter((member) => member.memberClass == 'CHILD');
  if (isLoading) {
    return <Skeleton active style={{ marginTop: 24 }} />;
  }

  if (!hasDependents) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <Typography.Text style={{ marginTop: 16, marginBottom: 16 }}>{t('profile.noDependents')}</Typography.Text>
        }
      />
    );
  }

  return (
    <>
      <DependentGroup title={t('profile.spouse')} dependents={spouse} isSpouse={true} />
      <DependentGroup title={t('profile.child')} dependents={children} isSpouse={false} />
    </>
  );
};

function getDependentSectionProps(data?: ProfileInfoResponse) {
  return {
    familyMembers: data?.familyMembers ?? [],
    isEmployee: data?.memberType == '0',
  };
}

const getSpouseData = (familyMembers: Array<ProfileInfoResponse['familyMembers'][number]>, isEmployee: boolean) => {
  let spouse = familyMembers.filter((member) => member.memberClass == 'SPOUSE');

  // If logged in as a dependent user, spouse data is the employee member class
  if (spouse.length == 0 && !isEmployee) {
    spouse = familyMembers.filter((member) => member.memberClass === 'EMPLOYEE');
  }

  return spouse;
};

export interface DependentData {
  name: string;
  memberType: string;
  submitAndViewValue: boolean;
  shortfallRight: boolean;
  registerStatus: boolean;
}

export default DependentsPage;
